import { hasPermission } from '@crm/shared'
import { createFileRoute, Link, redirect, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { useCreateLink } from '@/features/links/api'
import { LinkForm } from '@/features/links/link-form'
import { ApiClientError } from '@/lib/api'
import { fetchMe } from '@/lib/auth-query'

export const Route = createFileRoute('/_app/links/new')({
  beforeLoad: async ({ context }) => {
    const me = await fetchMe(context.queryClient)
    if (me && !hasPermission(me.user.role, 'links:create')) {
      throw redirect({ to: '/links' })
    }
  },
  component: NewLinkPage,
})

function NewLinkPage() {
  const navigate = useNavigate()
  const create = useCreateLink()
  const [error, setError] = useState<string | null>(null)

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <div>
        <Link
          to="/links"
          className="inline-flex items-center gap-1 text-sm text-[var(--color-muted-foreground)] hover:underline"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Back to links
        </Link>
        <h1 className="mt-1 text-2xl font-semibold">New registration link</h1>
      </div>

      <LinkForm
        submitLabel="Create link"
        loading={create.isPending}
        error={error}
        onCancel={() => navigate({ to: '/links' })}
        onSubmit={(values) => {
          setError(null)
          create.mutate(values, {
            onSuccess: (data) =>
              navigate({ to: '/links/$linkId', params: { linkId: data.link.id } }),
            onError: (e) =>
              setError(e instanceof ApiClientError ? e.message : 'Could not create the link'),
          })
        }}
      />
    </div>
  )
}
